import ClosedStore from './closedStore';
export default ClosedStore;
